import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Select.styles';
const Select = React.forwardRef((props, ref) => {
    const [open, setOpen] = React.useState(false);
    const { onClick, onBlur, onChange, ...rest } = props;
    return (React.createElement(S.Wrapper, { "data-open": open },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Select, { ref: ref, ...rest, "aria-labelledby": `${props.name}-label`, onChange: (e) => {
                    onChange?.(e);
                    setOpen(false);
                }, onClick: (e) => {
                    onClick?.(e);
                    setOpen(!open);
                }, onBlur: (e) => {
                    onBlur?.(e);
                    setOpen(false);
                } }))));
});
Select.displayName = 'Select';
export default Select;
